class VariantEditCartSelects extends HTMLElement{constructor(){var t;if(super(),this.variantSelect=this,this.item=$(this.variantSelect).closest(".product-edit-item"),this.variantSelect.classList.contains("has-default")&&(this.updateOptions(),this.updateMasterId(),this.renderProductInfo()),this.currentVariant?this.item[0]&&(this.item[0].dataset.inStock=this.currentVariant.available?"true":"false"):this.item[0].dataset.inStock="false",null!=this.currentVariant?.inventory_management){var e,a="edit_cart_inven_array_"+this.item.data("cart-edit-id"),i=window[a];if(void 0!=i){var r,s=parseInt(i[this.currentVariant.id]);this.item.find('input[name="quantity"]').attr("data-inventory-quantity",s)}}this.addEventListener("change",this.onVariantChange.bind(this))}onVariantChange(t){this.updateOptions(),this.updateMasterId(),this.currentVariant?(this.updateMedia(),this.updateVariantInput(),this.updatePrice(),this.renderProductInfo(),this.updateAttribute(!1,!this.currentVariant.available)):this.updateAttribute(!0),this.updateAddToCartButton(),window.show_multiple_currencies&&Currency.currentCurrency!=shopCurrency&&Currency.convertAll(window.shop_currency,$("#currencies .active").attr("data-currency"),"span.money","money_format")}updateOptions(){this.options=Array.from(this.querySelectorAll("select"),t=>t.value)}updateMasterId(){this.currentVariant=this.getVariantData().find(t=>!t.options.map((t,e)=>this.options[e]===t).includes(!1))}updateMedia(){if(!this.currentVariant||!this.currentVariant?.featured_image)return;let t=this.item.find(".product-edit-image"),e=this.currentVariant?.featured_image;t&&t.find("img").attr({src:e.src,srcset:e.src,alt:e.alt})}updateVariantInput(){let t=document.querySelector(`#product-form-edit-${this.dataset.product}`);if(!t)return;let e=t.querySelector('input[name="id"]');e&&(e.value=this.currentVariant.id,e.dispatchEvent(new Event("change",{bubbles:!0})))}updatePrice(){let t=this.item.find(".product-edit-price");if(t){var e=this.currentVariant?.price,a=this.currentVariant?.compare_at_price;t.find(".price").html(Shopify.formatMoney(e,window.money_format)).show(),a>e?(t.find(".compare-price").html(Shopify.formatMoney(a,window.money_format)).show(),t.find(".price").addClass("new-price")):(t.find(".compare-price").hide(),t.find(".price").removeClass("new-price"))}}renderProductInfo(){var t=this.getVariantData().filter(t=>t.available),e=this.currentVariant?.option1,a=this.currentVariant?.option2,i=this.currentVariant?.option3,r=this.currentVariant.title,s=this.getElementsByClassName("product-form__input");if(this.item.find("[data-change-title]").text(r),$.each(s,(r,n)=>{var d=$(n).data("option-index"),o=$(n).data("product-attribute");switch(d){case 0:if($(n).find("[data-header-option]").text(e),"set-select"==o){var l=$(n).find(".select__select").val(),c=$(n).find(".select__select option");c.each((t,e)=>{e.value==l?$(e).attr("selected","selected"):$(e).removeAttr("selected")})}var u=t.filter(t=>t.option1===e);if(a){var h=$(s[1]),v=h.find(".product-form__radio"),p=h.find(".select__select option");"set-rectangle"==o?v.each((t,e)=>{var a=$(e).next(),i=$(e).val();void 0==u.find(t=>t.option2==i)?a.removeClass("available").addClass("soldout"):a.removeClass("soldout").addClass("available")}):p.each((t,e)=>{var a=$(e),i=$(e).val();void 0==u.find(t=>t.option2==i)?a.attr("disabled",!0):a.removeAttr("disabled")})}if(i){var h=$(s[2]),v=h.find(".product-form__radio"),p=h.find(".select__select option");"set-rectangle"==o?v.each((t,e)=>{var a=$(e).next(),i=$(e).val();void 0==u.find(t=>t.option3==i)?a.removeClass("available").addClass("soldout"):a.removeClass("soldout").addClass("available")}):electOption.each((t,e)=>{var a=$(e),i=$(e).val();void 0==u.find(t=>t.option3==i)?a.attr("disabled",!0):a.removeAttr("disabled")})}break;case 1:if($(n).find("[data-header-option]").text(a),"set-select"==o){var l=$(n).find(".select__select").val(),c=$(n).find(".select__select option");c.each((t,e)=>{e.value==l?$(e).attr("selected","selected"):$(e).removeAttr("selected")})}var f=t.filter(t=>t.option2===a);if(e){var h=$(s[0]),v=h.find(".product-form__radio"),p=h.find(".select__select option");"set-rectangle"==o?v.each((t,e)=>{var a=$(e).next(),i=$(e).val();void 0==f.find(t=>t.option1==i)?a.removeClass("available").addClass("soldout"):a.removeClass("soldout").addClass("available")}):p.each((t,e)=>{var a=$(e),i=$(e).val();void 0==f.find(t=>t.option1==i)?a.attr("disabled",!0):a.removeAttr("disabled")})}if(i){var h=$(s[2]),v=h.find(".product-form__radio"),p=h.find(".select__select option");"set-rectangle"==o?v.each((t,e)=>{var a=$(e).next(),i=$(e).val();void 0==f.find(t=>t.option3==i)?a.removeClass("available").addClass("soldout"):a.removeClass("soldout").addClass("available")}):electOption.each((t,e)=>{var a=$(e),i=$(e).val();void 0==f.find(t=>t.option3==i)?a.attr("disabled",!0):a.removeAttr("disabled")})}break;case 2:if($(n).find("[data-header-option]").text(i),"set-select"==o){var l=$(n).find(".select__select").val(),c=$(n).find(".select__select option");c.each((t,e)=>{e.value==l?$(e).attr("selected","selected"):$(e).removeAttr("selected")})}var m=t.filter(t=>t.option3===i);if(e){var h=$(s[0]),v=h.find(".product-form__radio"),p=h.find(".select__select option");"set-rectangle"==o?v.each((t,e)=>{var a=$(e).next(),i=$(e).val();void 0==m.find(t=>t.option1==i)?a.removeClass("available").addClass("soldout"):a.removeClass("soldout").addClass("available")}):p.each((t,e)=>{var a=$(e),i=$(e).val();void 0==m.find(t=>t.option1==i)?a.attr("disabled",!0):a.removeAttr("disabled")})}if(a){var h=$(s[1]),v=h.find(".product-form__radio");"set-rectangle"==o?v.each((t,e)=>{var a=$(e).next(),i=$(e).val();void 0==m.find(t=>t.option2==i)?a.removeClass("available").addClass("soldout"):a.removeClass("soldout").addClass("available")}):p.each((t,e)=>{var a=$(e),i=$(e).val();void 0==m.find(t=>t.option2==i)?a.attr("disabled",!0):a.removeAttr("disabled")})}}}),null!=this.currentVariant?.inventory_management){var n=this.item.data("cart-edit-id"),d=window["edit_cart_inven_array_"+n];if(void 0!=d){var o=parseInt(d[this.currentVariant.id]);if(this.item.find('input[name="quantity"]').attr("data-inventory-quantity",o),this.item.find(".product-edit-hotStock").length>0){var l=this.item.find(".product-edit-hotStock"),c=l.data("edit-cart-hot-stock");if(o>0&&o<=c){var u=window.inventory_text.hotStock.replace("[inventory]",o);l.text(u).show()}else l.hide()}}}}updateAttribute(t=!0,e=!0){var a=this.item.find(".alertBox"),i=this.item.find('input[name="quantity"]'),r=this.item.find(".product-edit-notifyMe"),s=this.item.find(".productView-hotStock");t?(this.item.removeClass("isChecked"),i.attr("disabled",!0),a.find(".alertBox-message").text(window.variantStrings.unavailable_message),a.show(),r.slideUp("slow"),s.length>0&&s.hide()):e?(this.item.removeClass("isChecked"),i.attr("disabled",!0),a.find(".alertBox-message").text(window.variantStrings.soldOut_message),a.show(),this.item.find(".quantity__message").empty().hide(),r.length>0&&(r.find('input[name="halo-notify-product-variant"]').val(this.currentVariant.title),r.find(".notifyMe-text").empty(),r.slideDown("slow"))):(this.item.addClass("isChecked"),i.attr("disabled",!1),a.find(".alertBox-message").text(""),a.hide(),r.length>0&&r.slideUp("slow")),this.item[0]&&(this.item[0].dataset.inStock=this.currentVariant.available?"true":"false")}getVariantData(){return this.variantData=this.variantData||JSON.parse(this.querySelector('[type="application/json"]').textContent),this.variantData}updateAddToCartButton(){let t=this.variantSelect.closest("[data-template-cart-edit]");if(!t)return;let e=[...t.querySelectorAll(".product-edit-item")],a=this.variantSelect.closest("[data-edit-cart-popup]").querySelector("[data-update-cart-edit]"),i=e.every(t=>"true"==t.dataset.inStock);i?a.disabled=!1:a.disabled=!0}}customElements.define("variant-edit-selects",VariantEditCartSelects);class VariantEditCartRadios extends VariantEditCartSelects{constructor(){super()}updateOptions(){let t=Array.from(this.querySelectorAll("fieldset"));this.options=t.map(t=>Array.from(t.querySelectorAll("input")).find(t=>t.checked).value)}}customElements.define("variant-edit-radios",VariantEditCartRadios);class QuantityEditCartInput extends HTMLElement{constructor(){super(),this.input=this.querySelector("input"),this.changeEvent=new Event("change",{bubbles:!0}),this.item=$(this.input).closest(".product-edit-item"),this.input.addEventListener("change",this.onInputChange.bind(this)),this.querySelectorAll(".btn-quantity").forEach(t=>t.addEventListener("click",this.onButtonClick.bind(this)))}onButtonClick(t){t.preventDefault();var e=this.input.value,a=parseInt(this.input.dataset.inventoryQuantity);let i=Number(this.input.value);if(t.target.classList.contains("plus"))var r=i+1;else var r=i-1;if(e<1&&(r=1,this.input.value=r),e>a){var s=`quick_view_selling_array_${this.input.dataset.product}`,n=window[s][currentId];if(console.log(n),"deny"==n){r=a,this.input.value=r;let d=getInputMessage(a);showWarning(d,3e3)}}this.input.value=r,this.input.dispatchEvent(this.changeEvent)}onInputChange(t){t.preventDefault();var e=Number(this.input.value),a=Number(this.input.dataset.quantity);if(e<1)e=1,this.input.value=e;else if(a<e){var i=window.inventory_text.warningQuantity.replace("[inventory]",a);e=a,this.input.value=e,this.item.find(".quantity__message").text(i).show(),this.item.removeClass("isChecked")}else this.item.addClass("isChecked"),this.item.find(".quantity__message").empty().hide()}}customElements.define("quantity-edit-cart-input",QuantityEditCartInput);
// class VariantEditCartSelects extends HTMLElement {
//     constructor() {
//         super();
//         this.variantSelect = this;
//         this.item = $(this.variantSelect).closest('.product-edit-item');

//         if(this.variantSelect.classList.contains('has-default')){
//             this.updateOptions();
//             this.updateMasterId();
//             this.renderProductInfo();
//         }

//         if (!this.currentVariant) {
//             this.item[0].dataset.inStock = 'false'
//         } else {
//             if(this.item[0]) {
//               this.item[0].dataset.inStock = this.currentVariant.available ? 'true': 'false'
//             }
//         }

//         var inventory = this.currentVariant?.inventory_management;

//         if(inventory != null) {
//             var productId = this.item.data('cart-edit-id'),
//                 arrayInVarName = 'edit_cart_inven_array_' + productId,
//                 inven_array = window[arrayInVarName];

//             if(inven_array != undefined) {
//                 var inven_num = inven_array[this.currentVariant.id],
//                     inventoryQuantity = parseInt(inven_num);

//                 this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);
//             }
//         }

//         this.addEventListener('change', this.onVariantChange.bind(this));
//     }

//     onVariantChange(event) {
//         this.updateOptions();
//         this.updateMasterId();

//         if (!this.currentVariant) {
//             this.updateAttribute(true);
//         } else {
//             this.updateMedia();
//             this.updateVariantInput();
//             this.updatePrice();
//             this.renderProductInfo();
//             this.updateAttribute(false, !this.currentVariant.available);
//         }   
        
//         this.updateAddToCartButton();

//         if (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) {
//             Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//         }
//     }   

//     updateOptions() {
//         this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
//     }

//     updateMasterId() {
//         this.currentVariant = this.getVariantData().find((variant) => {
//             return !variant.options.map((option, index) => {
//                 return this.options[index] === option;
//             }).includes(false);
//         });
//     }

//     updateMedia() {
//         if (!this.currentVariant || !this.currentVariant?.featured_image) return;
//         const itemImage = this.item.find('.product-edit-image');
//         const image = this.currentVariant?.featured_image;

//         if (!itemImage) return;

//         itemImage.find('img').attr({
//             'src': image.src,
//             'srcset': image.src,
//             'alt': image.alt
//         });
//     }

//     updateVariantInput() {
//         const productForm = document.querySelector(`#product-form-edit-${this.dataset.product}`);

//         if (!productForm) return;

//         const input = productForm.querySelector('input[name="id"]');
        
//         if (!input) return;

//         input.value = this.currentVariant.id;
//         input.dispatchEvent(new Event('change', { bubbles: true }));
//     }

//     updatePrice(){
//         const itemPrice = this.item.find('.product-edit-price');

//         if (!itemPrice) return;

//         var price = this.currentVariant?.price,
//             compare_at_price = this.currentVariant?.compare_at_price;

//         itemPrice.find('.price').html(Shopify.formatMoney(price, window.money_format)).show();

//         if(compare_at_price > price) {
//             itemPrice.find('.compare-price').html(Shopify.formatMoney(compare_at_price, window.money_format)).show();
//             itemPrice.find('.price').addClass('new-price');
//         } else {
//             itemPrice.find('.compare-price').hide();
//             itemPrice.find('.price').removeClass('new-price');
//         }
//     }

//     renderProductInfo() {
//         var variantList = this.getVariantData().filter((variant) => {
//             return variant.available
//         });

//         var selectedOption1 = this.currentVariant?.option1,
//             selectedOption2 = this.currentVariant?.option2,
//             selectedOption3 = this.currentVariant?.option3,
//             selectedVariant = this.currentVariant.title,
//             options = this.getElementsByClassName('product-form__input');

//         this.item.find('[data-change-title]').text(selectedVariant);

//         $.each(options, (index, element) => {
//             var position = $(element).data('option-index'),
//                 type = $(element).data('product-attribute');

//             switch (position) {
//                 case 0:
//                     $(element).find('[data-header-option]').text(selectedOption1);

//                     if(type == 'set-select') {
//                         var selectValue = $(element).find('.select__select').val(),
//                             selectList = $(element).find('.select__select option');

//                         selectList.each((idx, elt) => {
//                             if(elt.value == selectValue){
//                                 $(elt).attr('selected', 'selected');
//                             } else {
//                                 $(elt).removeAttr('selected');
//                             }
//                         });
//                     }

//                     var option1List = variantList.filter((variant) => {
//                         return variant.option1 === selectedOption1;
//                     });

//                     if(selectedOption2){
//                         var inputList = $(options[1]),
//                             input = inputList.find('.product-form__radio'),
//                             selectOption = inputList.find('.select__select option');

//                         if(type == 'set-rectangle'){
//                             input.each((idx, elt) => {
//                                 var $input = $(elt),
//                                     $label = $input.next(),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option1List.find((variant) => {
//                                     return variant.option2 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $label.removeClass('available').addClass('soldout');
//                                 } else {
//                                     $label.removeClass('soldout').addClass('available');
//                                 }
//                             });
//                         } else {
//                             selectOption.each((idx, elt) => {
//                                 var $option = $(elt),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option1List.find((variant) => {
//                                     return variant.option2 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $option.attr('disabled', true);
//                                 } else {
//                                     $option.removeAttr('disabled');
//                                 }
//                             });
//                         }
//                     }

//                     if(selectedOption3){
//                         var inputList = $(options[2]),
//                             input = inputList.find('.product-form__radio'),
//                             selectOption = inputList.find('.select__select option');

//                         if(type == 'set-rectangle'){
//                             input.each((idx, elt) => {
//                                 var $input = $(elt),
//                                     $label = $input.next(),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option1List.find((variant) => {
//                                     return variant.option3 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $label.removeClass('available').addClass('soldout');
//                                 } else {
//                                     $label.removeClass('soldout').addClass('available');
//                                 }
//                             });
//                         } else {
//                             electOption.each((idx, elt) => {
//                                 var $option = $(elt),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option1List.find((variant) => {
//                                     return variant.option3 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $option.attr('disabled', true);
//                                 } else {
//                                     $option.removeAttr('disabled');
//                                 }
//                             });
//                         }
//                     }

//                     break;
//                 case 1:
//                     $(element).find('[data-header-option]').text(selectedOption2);

//                     if(type == 'set-select') {
//                         var selectValue = $(element).find('.select__select').val(),
//                             selectList = $(element).find('.select__select option');

//                         selectList.each((idx, elt) => {
//                             if(elt.value == selectValue){
//                                 $(elt).attr('selected', 'selected');
//                             } else {
//                                 $(elt).removeAttr('selected');
//                             }
//                         });
//                     }

//                     var option2List = variantList.filter((variant) => {
//                         return variant.option2 === selectedOption2;
//                     });

//                     if(selectedOption1){
//                         var inputList = $(options[0]),
//                             input = inputList.find('.product-form__radio'),
//                             selectOption = inputList.find('.select__select option');

//                         if(type == 'set-rectangle'){
//                             input.each((idx, elt) => {
//                                 var $input = $(elt),
//                                     $label = $input.next(),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option2List.find((variant) => {
//                                     return variant.option1 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $label.removeClass('available').addClass('soldout');
//                                 } else {
//                                     $label.removeClass('soldout').addClass('available');
//                                 }
//                             });
//                         } else {
//                             selectOption.each((idx, elt) => {
//                                 var $option = $(elt),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option2List.find((variant) => {
//                                     return variant.option1 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $option.attr('disabled', true);
//                                 } else {
//                                     $option.removeAttr('disabled');
//                                 }
//                             });
//                         }
//                     }

//                     if(selectedOption3){
//                         var inputList = $(options[2]),
//                             input = inputList.find('.product-form__radio'),
//                             selectOption = inputList.find('.select__select option');

//                         if(type == 'set-rectangle'){
//                             input.each((idx, elt) => {
//                                 var $input = $(elt),
//                                     $label = $input.next(),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option2List.find((variant) => {
//                                     return variant.option3 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $label.removeClass('available').addClass('soldout');
//                                 } else {
//                                     $label.removeClass('soldout').addClass('available');
//                                 }
//                             });
//                         } else {
//                             electOption.each((idx, elt) => {
//                                 var $option = $(elt),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option2List.find((variant) => {
//                                     return variant.option3 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $option.attr('disabled', true);
//                                 } else {
//                                     $option.removeAttr('disabled');
//                                 }
//                             });
//                         }
//                     }

//                     break;
//                 case 2:
//                     $(element).find('[data-header-option]').text(selectedOption3);

//                     if(type == 'set-select') {
//                         var selectValue = $(element).find('.select__select').val(),
//                             selectList = $(element).find('.select__select option');

//                         selectList.each((idx, elt) => {
//                             if(elt.value == selectValue){
//                                 $(elt).attr('selected', 'selected');
//                             } else {
//                                 $(elt).removeAttr('selected');
//                             }
//                         });
//                     }

//                     var option3List = variantList.filter((variant) => {
//                         return variant.option3 === selectedOption3;
//                     });

//                     if(selectedOption1){
//                         var inputList = $(options[0]),
//                             input = inputList.find('.product-form__radio'),
//                             selectOption = inputList.find('.select__select option');

//                         if(type == 'set-rectangle'){
//                             input.each((idx, elt) => {
//                                 var $input = $(elt),
//                                     $label = $input.next(),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option3List.find((variant) => {
//                                     return variant.option1 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $label.removeClass('available').addClass('soldout');
//                                 } else {
//                                     $label.removeClass('soldout').addClass('available');
//                                 }
//                             });
//                         } else {
//                             selectOption.each((idx, elt) => {
//                                 var $option = $(elt),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option3List.find((variant) => {
//                                     return variant.option1 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $option.attr('disabled', true);
//                                 } else {
//                                     $option.removeAttr('disabled');
//                                 }
//                             });
//                         }
//                     }

//                     if(selectedOption2){
//                         var inputList = $(options[1]),
//                             input = inputList.find('.product-form__radio');

//                         if(type == 'set-rectangle'){
//                             input.each((idx, elt) => {
//                                 var $input = $(elt),
//                                     $label = $input.next(),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option3List.find((variant) => {
//                                     return variant.option2 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $label.removeClass('available').addClass('soldout');
//                                 } else {
//                                     $label.removeClass('soldout').addClass('available');
//                                 }
//                             });
//                         } else {
//                             selectOption.each((idx, elt) => {
//                                 var $option = $(elt),
//                                     optionValue = $(elt).val();

//                                 var optionSoldout = option3List.find((variant) => {
//                                     return variant.option2 == optionValue
//                                 });

//                                 if(optionSoldout == undefined){
//                                     $option.attr('disabled', true);
//                                 } else {
//                                     $option.removeAttr('disabled');
//                                 }
//                             });
//                         }
//                     }

//                     break;
//             }
//         });

//         var inventory = this.currentVariant?.inventory_management;

//         if(inventory != null) {
//             var productId = this.item.data('cart-edit-id'),
//                 arrayInVarName = 'edit_cart_inven_array_' + productId,
//                 inven_array = window[arrayInVarName];

//             if(inven_array != undefined) {
//                 var inven_num = inven_array[this.currentVariant.id],
//                     inventoryQuantity = parseInt(inven_num);

//                 this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);

//                 if(this.item.find('.product-edit-hotStock').length > 0){
//                     var hotStock = this.item.find('.product-edit-hotStock'),
//                         maxStock = hotStock.data('edit-cart-hot-stock');

//                     if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
//                         var textStock = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
//                         hotStock.text(textStock).show();
//                     } else {
//                         hotStock.hide();
//                     }
//                 }
//             }
//         }
//     }

//     updateAttribute(unavailable = true, disable = true){
//         var alertBox = this.item.find('.alertBox'),
//             quantityInput = this.item.find('input[name="quantity"]'),
//             notifyMe = this.item.find('.product-edit-notifyMe'),
//             hotStock = this.item.find('.productView-hotStock');

//         if(unavailable){
//             this.item.removeClass('isChecked');
//             quantityInput.attr('disabled', true);
//             alertBox.find('.alertBox-message').text(window.variantStrings.unavailable_message);
//             alertBox.show();
//             notifyMe.slideUp('slow');

//             if(hotStock.length > 0){
//                 hotStock.hide();
//             }
//         } else {
//             if (disable) {
//                 this.item.removeClass('isChecked');
//                 quantityInput.attr('disabled', true);
//                 alertBox.find('.alertBox-message').text(window.variantStrings.soldOut_message);
//                 alertBox.show();

//                 this.item.find('.quantity__message').empty().hide();

//                 if(notifyMe.length > 0){
//                     notifyMe.find('input[name="halo-notify-product-variant"]').val(this.currentVariant.title);
//                     notifyMe.find('.notifyMe-text').empty();
//                     notifyMe.slideDown('slow');
//                 }
//             } else{
//                 this.item.addClass('isChecked')
//                 quantityInput.attr('disabled', false);
//                 alertBox.find('.alertBox-message').text('');
//                 alertBox.hide();

//                 if(notifyMe.length > 0){
//                     notifyMe.slideUp('slow');
//                 }
//             }
//         }

//         if (this.item[0]) {
//           this.item[0].dataset.inStock = this.currentVariant.available ? 'true' : 'false';
//         }
//     }

//     getVariantData() {
//         this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
//         return this.variantData;
//     }

//     updateAddToCartButton() {
//         const editCartWrapper = this.variantSelect.closest('[data-template-cart-edit]');
//         if (!editCartWrapper) return 
//         const productItems = [...editCartWrapper.querySelectorAll('.product-edit-item')];
//         const updateEditCartButton = this.variantSelect.closest('[data-edit-cart-popup]').querySelector('[data-update-cart-edit]');
//         const allValid = productItems.every(productItem => productItem.dataset.inStock == 'true');
        
//         if (allValid) {
//             updateEditCartButton.disabled = false 
//         } else {
//             updateEditCartButton.disabled = true
//         }
//     }
// }

// customElements.define('variant-edit-selects', VariantEditCartSelects);

// class VariantEditCartRadios extends VariantEditCartSelects {
//     constructor() {
//         super();
//     }

//     updateOptions() {
//         const fieldsets = Array.from(this.querySelectorAll('fieldset'));
//         this.options = fieldsets.map((fieldset) => {
//             return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
//         });
//     }
// }

// customElements.define('variant-edit-radios', VariantEditCartRadios);

// class QuantityEditCartInput extends HTMLElement {
//     constructor() {
//         super();
//         this.input = this.querySelector('input');
//         this.changeEvent = new Event('change', { bubbles: true })
//         this.item = $(this.input).closest('.product-edit-item');
//         this.input.addEventListener('change', this.onInputChange.bind(this));
//         this.querySelectorAll('.btn-quantity').forEach(
//             (button) => button.addEventListener('click', this.onButtonClick.bind(this))
//         );
//     }

//     onButtonClick(event) {
//         event.preventDefault();
//         var inputValue = this.input.value;
//         var maxValue = parseInt(this.input.dataset.inventoryQuantity);
//         const value = Number(this.input.value);
//         if (event.target.classList.contains('plus')) {
//             var newVal = value + 1;
//         } else {
//             var newVal = value - 1;
//         }

//         if(inputValue < 1) {
//             newVal = 1;
//             this.input.value =  newVal;
//         }  
              
//         if (inputValue > maxValue) {
//             var arrayInVarName = `quick_view_selling_array_${this.input.dataset.product}`,
//                 itemInArray = window[arrayInVarName],
//                 itemStatus = itemInArray[currentId];

//             console.log(itemStatus)
//             if(itemStatus == 'deny') {
//                 newVal = maxValue
//                 this.input.value =  newVal;
//                 const message = getInputMessage(maxValue);
//                 showWarning(message, 3000);
//             }
//         } 
      
//         this.input.value = newVal;
//         this.input.dispatchEvent(this.changeEvent);
//     }

//     onInputChange(event) {
//         event.preventDefault();
//         var inputValue = Number(this.input.value);
//         var inventoryQuantity = Number(this.input.dataset.quantity);

//         if(inputValue < 1) {
//             inputValue = 1;
//             this.input.value =  inputValue;
//         } else {
//             if (inventoryQuantity < inputValue) {
//                 var message = window.inventory_text.warningQuantity.replace('[inventory]', inventoryQuantity);

//                 inputValue = inventoryQuantity;
//                 this.input.value =  inputValue;

//                 this.item.find('.quantity__message').text(message).show();
//                 this.item.removeClass('isChecked');
//             } else {
//                 this.item.addClass('isChecked');
//                 this.item.find('.quantity__message').empty().hide();
//             }
//         }
//     }
// }

// customElements.define('quantity-edit-cart-input', QuantityEditCartInput);